import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'react-loading';

import DefaultInput from '../../../../components/Input';
import Button from '../../../../components/Button';
import Logo from '../../../../assets/images/logo-parquearauco.png';
import Icon from '../../../../assets/images/logo.png';
import {
  Container,
  Wrapper,
  Title,
  PreTitle,
  IconImg,
  Footer,
  SubTitle,
  CustomLink
} from '../../styles';

import { forgotPasswordSubmit } from '../../../../store/actions/AuthActions';
import { changePasswordSchema } from '../../constants';

export default function NewPassword() {
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [{ usernameError, codeError, newPasswordError }, setErrors] = useState({
    usernameError: false,
    codeError: false,
    newPasswordError: false
  });

  const loading = useSelector(state => state.auth.loading);

  function handleUsernameOnChange(e) {
    setUsername(e.target.value);
  }

  function handleCodeOnChange(e) {
    setCode(e.target.value);
  }

  function handleNewPasswordOnChange(e) {
    setNewPassword(e.target.value);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      submit();
    }
  }

  function handleOnClick() {
    submit();
  }

  async function submit() {
    try {
      setErrors({
        usernameError: false,
        codeError: false,
        newPasswordError: false
      });

      await changePasswordSchema.validate(
        { username, code, newPassword },
        { abortEarly: false }
      );

      dispatch(forgotPasswordSubmit(username, code, newPassword));
    } catch (err) {
      err.inner &&
        err.inner.map(error =>
          setErrors(prevState => ({
            ...prevState,
            [`${error.path}Error`]: true
          }))
        );
    }
  }

  return (
    <Container>
      <CustomLink to="/">
        <IconImg src={Logo} />
      </CustomLink>
      <Title>
        <PreTitle>SISTEMAS </PreTitle>AUTENTICACIÓN
      </Title>
      <Wrapper changePassword>
        <p>Cambiar contraseña</p>
        <SubTitle>
          La contraseña debe tener: 8 caracteres, mayúsculas (A-Z), minúsculas
          (a-z), números (0-9) y símbolos (#?!@$%^&*-)
        </SubTitle>
        <DefaultInput
          error={usernameError}
          label="USUARIO"
          placeholder="Usuario"
          placeholderColor="#bbb"
          onKeyDown={handleKeyDown}
          onChange={handleUsernameOnChange}
        />
        <DefaultInput
          error={codeError}
          label="CODIGO"
          placeholder="Codigo"
          placeholderColor="#bbb"
          onKeyDown={handleKeyDown}
          onChange={handleCodeOnChange}
        />
        <DefaultInput
          error={newPasswordError}
          label="NUEVA CONTRASEÑA"
          type="password"
          placeholder="Nueva contraseña"
          placeholderColor="#bbb"
          onKeyDown={handleKeyDown}
          onChange={handleNewPasswordOnChange}
        />
        <Button
          text={
            loading ? (
              <Loading height={15} width={15} type="spin" />
            ) : (
              'Ingresar'
            )
          }
          onClick={handleOnClick}
        />
      </Wrapper>
      <Footer>
        <IconImg src={Icon} />
      </Footer>
    </Container>
  );
}
